import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SubscriptionsSchema } from '@shared/store/subscription/types';
import { ITariffBase } from '@shared/store/tariff/types';

export const subscriptionsInitialState: SubscriptionsSchema = {
    chosenTariff: null,
};

const subscriptionsSlice = createSlice({
    name: 'subscriptions',
    initialState: subscriptionsInitialState,
    selectors: {
        getChosenTariff: (state) => state.chosenTariff,
    },
    reducers: {
        chooseTariff: (state, action: PayloadAction<ITariffBase | null>) => {
            state.chosenTariff = action.payload;
        },
    },
});

//actions
export const { actions: subscriptionsActions, selectors: subscriptionsSelectors } = subscriptionsSlice;

//reducer
export default subscriptionsSlice.reducer;
